module.exports = __webpack_public_path__ + "static/media/product4.aa1c8f68.jpg";